import type { HttpClient } from '@remodeling/base';
import {
  GetShopSidoRequest,
  GetShopSidoResponse,
  GetShopGunGusRequest,
  GetShopGunGusResponse,
  GetShopListRequest,
  GetShopClusterListRequest,
  GetShopClusterListResponse,
  GetShopListResponse,
  GetDisplayShopListRequest,
  GetDisplayShopListResponse,
} from '../../model/dto';
import queryString from 'query-string';

// 시도 목록 API
export class GetShopSidoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(_req: GetShopSidoRequest) {
    return await this.httpClient.request<GetShopSidoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops/sidos`,
    });
  }
}

// 군구 목록 API
export class GetShopGunGusGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetShopGunGusRequest) {
    const query = queryString.stringify(req);
    return await this.httpClient.request<GetShopGunGusResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops/gungus?${query}`,
    });
  }
}

// 매장 목록 API
export class GetShopListGateway {
  constructor(readonly httpClient: HttpClient) {}

  exec(req: GetShopListRequest) {
    const query = queryString.stringify(req);
    return this.httpClient
      .request<GetShopListResponse>({
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops?${query}`,
      })
      .then((result) => {
        if (result.code === 200) {
          return result;
        } else {
          throw new Error(result.message);
        }
      });
  }
}

// (남한 전경) 클러스터 목록 API
export class GetShopClusterListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetShopClusterListRequest) {
    const query = queryString.stringify(req);
    return await this.httpClient.request<GetShopClusterListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops/clusters?${query}`,
    });
  }
}

export class GetDisplayShopListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetDisplayShopListRequest) {
    const query = queryString.stringify(req);
    return await this.httpClient.request<GetDisplayShopListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops/goods/display?${query}`,
    });
  }
}
